import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Cart Drawer para Horizon con actualización real
 */
class CartDrawerComponent extends DialogComponent {

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener("cart:updated", this.#handleCartAdd);
    document.addEventListener("cart:item-added", this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener("cart:updated", this.#handleCartAdd);
    document.removeEventListener("cart:item-added", this.#handleCartAdd);
  }

  async #refreshDrawer() {
    try {

      // 🔥 FIX FINAL — ESTE ES EL HANDLE REAL DE TU ARCHIVO
      const response = await fetch('/cart?section_id=cart-drawer-1');

      const text = await response.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(text, "text/html");

      const newInner = html.querySelector(".cart-drawer__inner");
      const currentInner = this.querySelector(".cart-drawer__inner");

      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
      }

    } catch (err) {
      console.error("❌ Error refrescando cart drawer:", err);
    }
  }

  #handleCartAdd = async () => {
    await this.#refreshDrawer();

    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
